import React from 'react';
import styles from './Modal.module.css';

// {children} is the conten that will be displayed in the modal
// backdrop is covers the screen and closes the modal when clicked

const Modal = ({ children, onClose }) => {
  return (
    <>
      <div className={styles.backdrop} onClick={onClose}></div>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </>
  );
};

export default Modal;
